var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    bgcolor: ['home'].includes(_vm.$route.meta.layout),
  },attrs:{"id":"app"}},[(_vm.isHeader)?_c('Header'):_vm._e(),_c('router-view'),(_vm.isFooter)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }